import Api from './Api';
import Configuracao from '../util/Configuracao';

class CalculoCoparticipacaoApi extends Api {
  async consultarDemonstrativosNaoPagos (numDemonstrativo) {
    try {
      const urlConsultarDemonstrativosNaoPagos = Configuracao.getConfiguracao().urlConsultarDemonstrativosNaoPagos + numDemonstrativo;
      const response = await this.fetch(urlConsultarDemonstrativosNaoPagos);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarDemonstrativosNaoPagosOdonto (numDemonstrativo) {
    try {
      const urlConsultarDemonstrativosNaoPagosOdonto = Configuracao.getConfiguracao().urlConsultarDemonstrativosNaoPagosOdonto + numDemonstrativo;
      const response = await this.fetch(urlConsultarDemonstrativosNaoPagosOdonto);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async calcularCoparticipacao (numDemonstrativo, procedimentos) {
    try {
      const urlCalcularCoparticipacao = Configuracao.getConfiguracao().urlCalcularCoparticipacao + numDemonstrativo;
      const response = await this.fetch(urlCalcularCoparticipacao, 'post', procedimentos);
      return response;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
  async calcularCoparticipacaoOdonto (numDemonstrativo) {
    try {
      const urlCalcularCoparticipacaoOdonto = Configuracao.getConfiguracao().urlCalcularCoparticipacaoOdonto + numDemonstrativo;
      const response = await this.fetch(urlCalcularCoparticipacaoOdonto, 'post');
      return response;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
  async getProcedimentos () {
    try {
      const urlConsultarTodosProcedimentos = Configuracao.getConfiguracao().urlConsultarTodosProcedimentos;
      const response = await this.fetch(urlConsultarTodosProcedimentos);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async lancarCoparticipacao () {
    try {
      const urlLancarCoparticipacao = Configuracao.getConfiguracao().urlLancarCoparticipacao;
      const response = await this.fetch(urlLancarCoparticipacao, 'get');
      return response;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
}

export default CalculoCoparticipacaoApi;
